import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UnitDto } from '../../../../generated-model/models';
import { PageResponse } from '../../../shared/commons/page-response';

@Injectable({ providedIn: 'root' })
export class UnitService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/master/units';

  getAllUnits(page: number, size: number, search: string = "", state: number | null = null): Observable<PageResponse<UnitDto>> {
    return this.http.get<PageResponse<UnitDto>>(this.apiUrl + '?page=' + page + '&size=' + size + '&search=' + encodeURIComponent(search) + (state == null ? '' : '&state=' + state));
  }

  getActiveUnits(): Observable<UnitDto[]> {
    return this.http.get<UnitDto[]>(`${this.apiUrl}/active`);
  }

  getUnitById(id: number): Observable<UnitDto> {
    return this.http.get<UnitDto>(`${this.apiUrl}/${id}`);
  }

  createUnit(unit: UnitDto): Observable<UnitDto> {
    return this.http.post<UnitDto>(this.apiUrl, unit);
  }

  updateUnit(id: number, unit: UnitDto): Observable<UnitDto> {
    return this.http.put<UnitDto>(`${this.apiUrl}/${id}`, unit);
  }

  deleteUnit(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
